import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import './FooterList.scss';
import Icon from '../Icon/Icon';

export default function FooterList({ title, links }) {
  return (
    <li className="footer-list">
      <h2 className="footer-list__title">{title}</h2>
      <ul className="footer-list__links">
        {links.map(({ text, url, isLocal, icon }, i) => (
          <li className="footer-list__link-item" key={i}>
            {isLocal ? (
              <Link className="footer-list__link" to={url}>
                {icon && <Icon icon={icon} widthPixelSizes={[16, 18, 20]} />}
                {text}
              </Link>
            ) : (
              <a
                className="footer-list__link"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                {icon && <Icon icon={icon} widthPixelSizes={[16, 18, 20]} />}
                {text}
              </a>
            )}
          </li>
        ))}
      </ul>
    </li>
  );
}

FooterList.propTypes = {
  title: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};
